import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "hpsfir-card goods" }
const _hoisted_2 = { class: "goods-container" }
const _hoisted_3 = { class: "category-nav" }
const _hoisted_4 = { class: "goods-content" }
const _hoisted_5 = { class: "header-actions" }

import {
  HpsfirProTable,
  HpsfirProTableColumn,
  HpsfirProTableData,
  HpsfirProTableFilter,
  HpsfirProTableGetDataFunction,
  useBaseAsync,
  useBaseUserStore,
} from 'hpsfir-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref, computed } from 'vue';
import GoodsEditorDialog from './components/goods-editor-dialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = ref<HpsfirProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof HpsfirProTable>>();
const categoryOptions = ref<{ label: string; value: number }[]>([]);
const selectedCategoryId = ref<number>(0);
const baseUserStore = useBaseUserStore();
const editorVisible = ref(false);
const editorMode = ref<'create' | 'edit'>('create');
const editorSubmitting = ref(false);
const editingGoods = ref<Record<string, any> | undefined>();


const addInitValue = computed(() => ({
  isOnSale: true,
  sequence: 0,
  stock: 0,
  giftPoints: 0,
  specs: [],
  ...(selectedCategoryId.value ? { categoryId: selectedCategoryId.value } : {}),
}));

const editorInitialValue = computed(() => {
  if (editorMode.value === 'create') {
    return addInitValue.value;
  }
  return editingGoods.value;
});

const uploadHeaders = computed(() => ({
  Authorization: baseUserStore.token,
}));

const conditionsInitValue = {
};

// 加载分类选项
const loadCategoryOptions = useBaseAsync(async() => {
  const res = await useApi().categoryApi.listCategorycategory({
    conditions: {},
  });
  categoryOptions.value = (res.data.data || []).map((item: any) => ({
    label: item.name,
    value: item.id,
  }));
});

// 创建列定义
// eslint-disable-next-line max-lines-per-function
const createColumns = () => [
  {
    name: 'sequence',
    label: '排序',
    type: 'number',
    min: 0,
    step: 1,
    width: 80,
  },
  {
    name: 'categoryId',
    label: '分类',
    type: 'select',
    hideTable: true,
    options: categoryOptions.value,
    rule: [{ required: true, message: '请选择分类' }],
    width: 120,
  },
  {
    name: 'image',
    label: '图片',
    type: 'image',
    rule: [{ required: true, message: '请上传图片' }],
    action: useApi().uploadFileUrl,
    method: 'post',
    fieldName: 'files',
    headers: {
      Authorization: baseUserStore.token,
    },
    baseUrl: useApi().baseUrl,
    multiple: false,
    onSuccess(data) {
      console.log(data.data[0]);
      tableRef.value?.tableForm?.setOneFormState('image', data.data[0]);
    },
    width: 200,
  },
  {
    name: 'name',
    label: '名称',
    type: 'string',
    isCondition: true,
    rule: [{ required: true, message: '请输入名称' }],
    width: 150,
  },
  {
    name: 'description',
    label: '描述',
    type: 'string',
    rule: [{ required: true, message: '请输入描述' }],
    width: 200,
  },
  {
    name: 'price',
    label: '价格',
    type: 'string',
    rule: [
      { required: true, message: '请输入价格' },
      {
        pattern: /^\d+(?:\.\d{1,2})?$/u,
        message: '价格格式不正确，最多保留两位小数',
      },
    ],
    width: 100,
    render(scope) {
      if (scope.row.isPointsExchange) {
        return (<span>{scope.row.price} 积分</span>);
      }
      return (<span>¥ {scope.row.price}</span>);
    },
  },
  {
    name: 'isPointsExchange',
    label: '积分兑换商品',
    type: 'swtich',
    width: 120,
    render(scope) {
      return scope.row.isPointsExchange
        ? <el-tag type="warning">积分兑换</el-tag>
        : <el-tag type="info">普通商品</el-tag>;
    },
  },
  {
    name: 'specs',
    label: '规格',
    type: 'string',
    width: 180,
    render(scope) {
      const specs = scope.row.specs || [];
      if (!specs.length) {
        return (<span>-</span>);
      }
      return (<span>{specs.map((item: any) => item.name).join(' / ')}（{specs.length}组）</span>);
    },
  },
  {
    name: 'giftPoints',
    label: '赠送积分',
    type: 'number',
    min: 0,
    step: 1,
    width: 100,
  },
  {
    name: 'stock',
    label: '库存',
    type: 'number',
    rule: [{ required: true, message: '请输入库存' }],
    min: 0,
    step: 1,
    width: 140,
    render(scope) {
      return (
        <div class="stock-cell">
          <span>{scope.row.stock}</span>
          {scope.row.stock < 10 && <el-tag type="danger" size="small">库存紧张</el-tag>}
        </div>
      );
    },
  },
  {
    name: 'isOnSale',
    label: '是否上架',
    type: 'swtich',
    hideTable: true,
    width: 100,
  },
  {
    name: 'createTime',
    label: '创建时间',
    type: 'string',
    hideEdit: true,
    hideCreate: true,
    width: 180,
  },
] as HpsfirProTableColumn[];

// 初始化
const init = useBaseAsync(async() => {
  await loadCategoryOptions();
  columns.value = createColumns();
});

// 上架操作
const handleOnSale = useBaseAsync(async(row: any) => {
  await useApi().goodsApi.updateGoodsgoods({
    goodsAdminVo: {
      ...row,
      isOnSale: true,
    },
  });
  ElMessage.success('上架成功');
  tableRef.value?.refresh();
});

// 下架操作
const handleOffSale = useBaseAsync(async(row: any) => {
  await useApi().goodsApi.updateGoodsgoods({
    goodsAdminVo: {
      ...row,
      isOnSale: false,
    },
  });
  ElMessage.success('下架成功');
  tableRef.value?.refresh();
});

const operates = [
  {
    key: 'customEdit',
    name: '编辑',
    handler: (row: any) => {
      editorMode.value = 'edit';
      editingGoods.value = {
        ...row,
        specs: row.specs || [],
      };
      editorVisible.value = true;
    },
  },
  {
    key: 'onSale',
    name: '上架',
    handler: handleOnSale,
  },
  {
    key: 'offSale',
    name: '下架',
    handler: handleOffSale,
  },
];

const loading = ref(false);
const activeTab = ref<'onSale' | 'offSale'>('onSale');

// 切换标签时刷新表格
const handleTabChange = () => {
  tableRef.value?.refresh();
};

// 切换分类
const handleCategorySelect = (index: string) => {
  selectedCategoryId.value = Number(index);
  tableRef.value?.refresh();
};

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().goodsApi.pageGoodsgoods({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }

        conditions[key] = val;

        return conditions;
      }, {
        isOnSale: activeTab.value === 'onSale',
        ...(selectedCategoryId.value === 0 ? {} : { categoryId: selectedCategoryId.value }),
      } as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: (res.data.data?.data || []).map((item: any) => ({
        ...item,
        hideOp: {
          onSale: item.isOnSale,
          offSale: !item.isOnSale,
        },
      })),
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `【删除后，并不影响已经获取的商品券与订单，但会影响券类型中绑定的商品】您确定要删除商品"${row.name || '未命名'}"吗？此操作不可恢复，请谨慎操作`;

function openCreateDialog() {
  editorMode.value = 'create';
  editingGoods.value = undefined;
  editorVisible.value = true;
}

function openEditDialog(row: any) {
  editorMode.value = 'edit';
  editingGoods.value = {
    ...row,
    specs: row.specs || [],
  };
  editorVisible.value = true;
}

const submitGoods = useBaseAsync(async(data: any) => {
  try {
    editorSubmitting.value = true;
    const payload = {
      ...data,
    };
    if (editorMode.value === 'create') {
      await useApi().goodsApi.addGoodsgoods({
        goodsAdminVo: payload,
      } as any);
      ElMessage.success('添加成功');
    } else {
      await useApi().goodsApi.updateGoodsgoods({
        goodsAdminVo: payload,
      } as any);
      ElMessage.success('修改成功');
    }
    editorVisible.value = false;
    tableRef.value?.refresh();
  } finally {
    editorSubmitting.value = false;
  }
});

const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().goodsApi.delGoodsgoods(data.id);
  ElMessage.success('删除成功');
});

Promise.all([init()]);

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_menu, {
          "default-active": String(selectedCategoryId.value),
          onSelect: handleCategorySelect
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, { index: "0" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("span", null, "全部分类", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "-1" }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("span", null, "未分类", -1)
              ]))]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryOptions.value, (category) => {
              return (_openBlock(), _createBlock(_component_el_menu_item, {
                key: category.value,
                index: String(category.value)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(category.label), 1)
                ]),
                _: 2
              }, 1032, ["index"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["default-active"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_tabs, {
            modelValue: activeTab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
            onTabChange: handleTabChange,
            class: "flex-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "已上架",
                name: "onSale"
              }),
              _createVNode(_component_el_tab_pane, {
                label: "仓库中",
                name: "offSale"
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: openCreateDialog
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("创建商品", -1)
            ]))]),
            _: 1
          })
        ]),
        _createVNode(_unref(HpsfirProTable), {
          ref_key: "tableRef",
          ref: tableRef,
          paginations: { pageSize: 10 },
          "page-layout": "total, sizes, prev, pager, next",
          columns: columns.value,
          "get-data": _unref(getData),
          "on-delete": _unref(deleteFun),
          loading: loading.value,
          "is-dangder-delete": true,
          "format-dangder-delete-info": formatDeleteInfo,
          "row-key": "id",
          operates: operates,
          "codition-init-values": conditionsInitValue,
          "hide-create": true,
          "hide-edit": true
        }, null, 8, ["columns", "get-data", "on-delete", "loading"])
      ])
    ]),
    _createVNode(GoodsEditorDialog, {
      visible: editorVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((editorVisible).value = $event)),
      mode: editorMode.value,
      "initial-value": editorInitialValue.value,
      "category-options": categoryOptions.value,
      "upload-url": _unref(useApi)().uploadFileUrl,
      "upload-headers": uploadHeaders.value,
      "base-url": _unref(useApi)().baseUrl,
      submitting: editorSubmitting.value,
      onSubmit: _unref(submitGoods)
    }, null, 8, ["visible", "mode", "initial-value", "category-options", "upload-url", "upload-headers", "base-url", "submitting", "onSubmit"])
  ]))
}
}

})